import noodleMediaClient, { type ApiDefinitions } from '@/tsClient/servers/noodleMedia';
import { type RequireExactlyOne } from '@/typings/utility';

type ThisApi = ApiDefinitions['/file']['GET'];
type Props = ThisApi['query'];

const getMediaData = async (params: RequireExactlyOne<Props>): Promise<ThisApi['response']> => {
  const response = await noodleMediaClient.get('/file', { params: { ...params } });
  return response.data?.media || response.data || null;
};

export default getMediaData;
